const state = {
    contacts: [],
    participant: {}
}

const getters = {
    //
}

const mutations = {
    setContacts (state, data) {
        return state.contacts = data
    },
    setParticipant (state, data) {
        return state.participant = data
    }
}

const actions = {
    deleteContact(context, contact) {
        if(confirm('You are about to delete a contact along with their channels and communication logs. This cannot be undone. Are you sure you want to continue?')) {
            axios.delete('/api/contacts/' + contact.id)
                .then(response => {
                    context.dispatch("fetchContacts", {'participant_id': state.participant.id});
                    context.dispatch("communications/fetchLogs", {'participant_id': state.participant.id}, {root: true})
                    context.dispatch("communications/fetchContacts", {'participant_id': state.participant.id}, {root: true})
                });
        }
    },
    fetchContacts(context, data) {
        axios.get('/api/contacts', {params: data})
        .then( (response) => {
            context.commit("setContacts", response.data)
        })
        .catch( (e) => {
            console.log("Error: contacts.js, fetchContacts(), "+ e.message)          
        })
    },
    setContacts(context, data) {
        context.commit("setContacts", data)
    },
    setParticipant(context, data) {
        context.commit("setParticipant", data)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}